import { render, staticRenderFns } from "./SalonLista.vue?vue&type=template&id=69ac37cc&"
import script from "./SalonLista.vue?vue&type=script&lang=js&"
export * from "./SalonLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports